<template>
  <div class="bg">
    <div class="body">
      <h1 class="mod-title">
        <span class="ico_log ico-1"></span>
      </h1>

      <div class="mod-ct">
        <div class="order"></div>
        <div class="amount" id="money">
          <span style="font-size: 30px">￥</span>
          {{ order.price }}
        </div>
        <div class="qrcode-img-wrapper" data-role="qrPayImgWrapper">
          <div data-role="qrPayImg" class="qrcode-img-area">
            <div style="position: relative; display: inline-block">
              <img v-lazy="base_img" style="display: block; width: 210px" />
            </div>
          </div>
        </div>

        <div class="tip">
          <div class="tip-btn" v-if="isMobile" @click="openAli">使用支付宝APP付款</div>
          <div v-else>
            <div class="ico-scan"></div>
            <div class="tip-text">
              <p>请使用支付宝扫一扫</p>
              <p>扫描二维码完成支付</p>
            </div>
          </div>
        </div>

        <div class="detail" :class="open ? 'detail-open' : ''">
          <dl class="detail-ct" :style="open ? 'height: 130px' : ''">
            <dt>商品名称</dt>
            <dd>{{ order.goods_name }}</dd>
            <dt>商户单号</dt>
            <dd>{{ order.out_trade_no }}</dd>
            <dt>金额</dt>
            <dd>￥{{ order.price }}</dd>
            <dt>创建时间</dt>
            <dd>{{ order.addTime }}</dd>
          </dl>
          <a href="javascript:void(0)" class="arrow" @click="open = !open"
            ><i class="ico-arrow"></i
          ></a>
        </div>

        <div class="tip-text"></div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { postPay, getOrder, getStatus } from "@/api/index";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      open: false,
      out_trade_no: "",
      order: {},
      code_url: "",
      base_img: "",
    };
  },
  computed: {
    ...mapState(["isMobile"]),
  },
  created() {
    this.out_trade_no = this.$route.params.out_trade_no;
    this._getOrder(this.$route.params.out_trade_no);
    this._postPay(this.$route.params.out_trade_no);
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timers = setInterval(() => {
      _this._getStatus(_this.out_trade_no);
    }, 3000);
  },

  methods: {
    // 提交支付
    _postPay(out_trade_no) {
      postPay({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          this.code_url = res.data.code_url;
          this.base_img = res.data.base_img;

          // //  生成二维码
          // let qrcode = new QRCode("qrcode", {
          //   width: 200,
          //   height: 200, // 高度
          //   text: res.data, // 二维码内容
          //   colorDark: "#000000", //前景色
          //   colorLight: "#ffffff", //背景色
          //   correctLevel: QRCode.CorrectLevel.L, //容错等级
          // });

          this.openAli();
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },

    openAli() {
      var a = document.createElement("a");
      a.setAttribute(
        "href",
        `alipays://platformapi/startapp?saId=10000007&qrcode=${this.code_url}`
      );
      document.body.appendChild(a);
      a.style.display = "none";
      a.click();
    },

    // 查询订单
    _getOrder(out_trade_no) {
      getOrder({
        out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          this.order = res.data;
          this.open = true
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },

    // 查询状态
    _getStatus(out_trade_no) {
      getStatus({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.data) {
          clearInterval(this.timers);
          if (this.isMobile == true) {
            this.$router.push("/m/query");
          } else {
            this.$router.push("/query");
          }
          
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../../assets/css/pay.css");
</style>